/* eslint-disable @typescript-eslint/no-explicit-any */
import { getStorage, setStorage, StorageTypes } from '@helpers/storage';

interface AiSearchState { accepted: boolean; enabled: boolean }

const key = (): string => `aiSearch_${(window as any).BFG?.currentUser?.user_id || 'anon'}`;

export const getAiSearch = (): AiSearchState => {
  const v = getStorage<AiSearchState>(StorageTypes.Local, key());
  return { accepted: !!v?.accepted, enabled: !!v?.enabled };
};

export const setAiSearch = (patch: Partial<AiSearchState>): void => {
  setStorage(StorageTypes.Local, key(), { ...getAiSearch(), ...patch });
};

export const semanticSearchFeature = (): boolean => (
  !!((window as any).BFG?.hasFeature?.('semantic_search')
    || (window as any).BFG?.context?.hasFeature?.('semantic_search'))
);

export const userNlsEnabled = (): boolean => !!(window as any).BFG?.currentUser?.nlsEnabled;

export const isAiSearchOn = (): boolean => semanticSearchFeature() && userNlsEnabled() && getAiSearch().enabled;
